export default __webpack_public_path__ + "static/media/brainhealth@3x.57d285cc.jpg";